/**
 * @generated SignedSource<<dae2419c73d502fc322fcbcf931ff033>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useProductDimensions_measurement$data = {
  readonly display: ReadonlyArray<{
    readonly unit: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly size: {
    readonly value: string | null;
  } | null;
  readonly " $fragmentType": "useProductDimensions_measurement";
};
export type useProductDimensions_measurement$key = {
  readonly " $data"?: useProductDimensions_measurement$data;
  readonly " $fragmentSpreads": FragmentRefs<"useProductDimensions_measurement">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useProductDimensions_measurement",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ItemMeasurement",
  "abstractKey": null
};
})();

(node as any).hash = "df337c8afff552f1365788c9fbb431a7";

export default node;
